import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { fadeUp, viewport } from "../../lib/motion";
import { IMAGES } from "../../lib/site";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#000000] min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden"
    >
      {/* Faint power icon background */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img
          src={IMAGES.power}
          alt=""
          aria-hidden="true"
          className="opacity-[0.11] select-none"
          style={{ width: "min(360px, 55vw)", height: "auto" }}
        />
      </div>

      {/* Radial white glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.06), transparent 60%)",
        }}
      />

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewport}
        className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12 text-center"
      >
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.95] text-[#f5f5f7] glow-text">
          <span className="block">Seu celular</span>
          <span className="block">não pode esperar.</span>
        </h2>

        <div className="mt-12 flex justify-center">
          <WhatsAppCTA
            label="Falar no WhatsApp"
            pulse
            icon={<MessageCircle size={18} />}
            testId="final-cta-whatsapp"
          />
        </div>
      </motion.div>
    </section>
  );
};
